function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SpaceTemplate = require('./space.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SpaceOverlay = /*#__PURE__*/function () {
  function SpaceOverlay(app, mod) {
    _classCallCheck(this, SpaceOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, true, false);
  }
  return _createClass(SpaceOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var spacekey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var space = this.mod.game.spaces[spacekey];
      this.overlay.show(SpaceTemplate());

      //
      // add battle information
      //
      document.querySelector('.space-overlay .name').innerHTML = space.name + ' - ' + space.country;
      var html = '';
      for (var z = 0; z < space.units.length; z++) {
        html += this.mod.returnUnitImage(space.units[z]);
      }
      document.querySelector('.space-overlay .units').innerHTML = html;
      document.querySelector('.space-overlay .status').innerHTML = 'in supply';
      document.querySelector('.space-overlay .control').innerHTML = space.control + ' control';
      if (!this.mod.checkSupplyStatus(space.control, spacekey)) {
        document.querySelector('.space-overlay .status').innerHTML = 'out-of-supply';
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = SpaceOverlay;